import { render, staticRenderFns } from "./PetsNicheIcon.vue?vue&type=template&id=738a8ed8&scoped=true"
import script from "./PetsNicheIcon.vue?vue&type=script&lang=js"
export * from "./PetsNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a8ed8",
  null
  
)

export default component.exports